import { useTranslation } from "react-i18next";
import { Boxes, Trash2 } from "lucide-react";
import { useAppDispatch } from "../../../app/hooks";
import { ImportGroup } from "../models/ImportGroup";
import { removeGroup, updateGroup } from "../assistant-import-slice";

interface ProposalGroupsSectionProps {
  groups: ImportGroup[];
  memberNamesByTempId: Map<string, string>;
}

export function ProposalGroupsSection({ groups, memberNamesByTempId }: ProposalGroupsSectionProps) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  if (groups.length === 0) return null;

  return (
    <div className="with-border rounded-2xl p-4 lg:p-6">
      <div className="mb-4 flex items-center gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary-95 text-primary-50 dark:bg-primary-30 dark:text-primary-80">
          <Boxes size={20} strokeWidth={2} />
        </span>
        <h2 className="text-lg font-semibold">
          {t("assistantImport.review.groups")} ({groups.length})
        </h2>
      </div>

      <div className="space-y-3">
        {groups.map((group) => (
          <div key={group.tempId} className="rounded-xl bg-grey-95 dark:bg-primary-20 p-3">
            <div className="flex items-center gap-2">
              <input
                className="input flex-1"
                aria-label={t("assistantImport.review.groupName")}
                value={group.name}
                onChange={(e) =>
                  dispatch(updateGroup({ tempId: group.tempId, changes: { name: e.target.value } }))
                }
              />
              <button
                type="button"
                className="btn btn-text text-red-700 dark:text-red-400"
                aria-label={t("common.remove")}
                onClick={() => dispatch(removeGroup(group.tempId))}
              >
                <Trash2 size={18} />
              </button>
            </div>
            <div className="mt-2 flex flex-wrap gap-1.5">
              {group.memberTempIds.map((tempId) => (
                <span
                  key={tempId}
                  className="rounded-full bg-primary-90 dark:bg-primary-30 px-2 py-0.5 text-sm text-primary-30 dark:text-primary-90"
                >
                  {memberNamesByTempId.get(tempId) ?? tempId}
                </span>
              ))}
              {group.memberTempIds.length === 0 && (
                <span className="text-sm text-grey-50 dark:text-grey-70">
                  {t("assistantImport.review.emptyGroup")}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
